import { render, staticRenderFns } from "./RChart.vue?vue&type=template&id=731289be&scoped=true"
import script from "./RChart.vue?vue&type=script&lang=js"
export * from "./RChart.vue?vue&type=script&lang=js"
import style0 from "./RChart.vue?vue&type=style&index=0&id=731289be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731289be",
  null
  
)

export default component.exports